import { Constants } from '../../shared/Constants.js';

/**
 * Calendar header + view navigation.
 */
export function renderHeader(picker) {
  const $ = window.jQuery;
  const GDT = window.GenericDateTime;
  const view = picker.state.view;
  if (view === Constants.Views.TIME) {
    return $('<div class="gdp-header" style="justify-content: center;"><div class="gdp-title">Select Time</div></div>');
  }

  const viewDate = GDT.from(picker.state.viewDate);
  const $header = $(
    `<div class="gdp-header">
        <button class="gdp-nav-btn gdp-prev"><i class="bi bi-chevron-left"></i></button>
        <div class="gdp-view-label"></div>
        <button class="gdp-nav-btn gdp-next"><i class="bi bi-chevron-right"></i></button>
      </div>`,
  );

  const $label = $header.find('.gdp-view-label');

  if (view === Constants.Views.DAYS) {
    const $month = $(`<span class="gdp-month-switch">${viewDate.withFormat({ month: 'long' }).asString()}</span>`);
    const $year = $(`<span class="gdp-year-switch">${viewDate.get('year')}</span>`);

    $month.on('click', () => {
      picker.state.view = Constants.Views.MONTHS;
      picker._updateContent();
    });
    $year.on('click', () => {
      picker.state.view = Constants.Views.YEARS;
      picker._updateContent();
    });

    $label.append($month, ' ', $year);
  } else if (view === Constants.Views.MONTHS) {
    const $year = $(`<span class="gdp-year-switch">${viewDate.get('year')}</span>`);
    $year.on('click', () => {
      picker.state.view = Constants.Views.YEARS;
      picker._updateContent();
    });
    $label.append($year);
  } else if (view === Constants.Views.YEARS) {
    const year = viewDate.get('year');
    const startYear = Math.floor(year / 10) * 10;
    $label.text(`${startYear} - ${startYear + 9}`);
  }

  $header.find('.gdp-prev').on('click', () => navigate(picker, -1));
  $header.find('.gdp-next').on('click', () => navigate(picker, 1));

  return $header;
}

export function navigate(picker, dir) {
  const date = picker.state.viewDate;
  if (picker.state.view === Constants.Views.DAYS) {
    date.setMonth(date.getMonth() + dir);
  } else if (picker.state.view === Constants.Views.MONTHS) {
    date.setFullYear(date.getFullYear() + dir);
  } else if (picker.state.view === Constants.Views.YEARS) {
    date.setFullYear(date.getFullYear() + dir * 10);
  }
  picker._updateContent();
}
